import React from 'react';
import ReactDOMServer from 'react-dom/server';
import Helmet from 'react-helmet';

import RichText from 'components/common/RichText';
export default function (faqs, sectionMarkup, key) {
  const faqPageEntities = faqs.map(faq => {
    if (!faq?.contentRt) return;

    let answer = ReactDOMServer.renderToString(<RichText document={faq.contentRt} />);
    answer = answer.replace('<p>', '');
    answer = answer.replace('</p>', '');
    return {
      '@type': 'Question',
      name: faq.heading,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    };
  });

  const faqPageJSON = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqPageEntities,
  };

  return (
    <React.Fragment key={key}>
      {faqPageJSON && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(faqPageJSON)}</script>
        </Helmet>
      )}
      {sectionMarkup}
    </React.Fragment>
  );
}
